import logo from './logo.svg';
import './App.css';
import PublicRoutes from './Routes/PublicRoutes';

function App() {
  return (
    <>
      <PublicRoutes />
    </>
  );
}

export default App;
